<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">WPCal.io - {{ T__("Plan Settings") }}</h1>
        <AdminHeaderRight />
      </div>
      <SettingsMenu />
      <div class="col-cont settings-cont">
        <div class="col">
          <div style="font-size: 16px; padding: 5px 0px;">
            {{ T__("Your Plan") }}
          </div>
          <div class="mbox" v-if="license_info.email">
            <table>
              <tr>
                <td
                  style="text-align:right; vertical-align:top;"
                  class="txt-help"
                >
                  {{ T__("License email:") }}
                </td>
                <td>
                  {{ license_info.email }} <br /><a
                    style="display:inline-block; margin-bottom:5px;"
                    @click="show_change_email_confirmation"
                    >{{ T__("Change account") }}</a
                  >
                  &bull;
                  <router-link
                    to="/settings/account/login"
                    style="display:inline-block; margin-bottom:5px;"
                    >{{ T__("Re-login") }}</router-link
                  >
                  <span
                    :style="{
                      display: this.$store.getters.is_debug ? '' : 'none'
                    }"
                  >
                    &bull;<a
                      style="display:inline-block; margin-bottom:5px;"
                      @click="force_validate_next_instance_and_dummy_call"
                      >{{ T__("__Reset & validate__") }}</a
                    >
                  </span>
                </td>
              </tr>
              <tr v-if="license_info.plan_name">
                <td style="text-align:right;" class="txt-help">
                  {{ T__("Plan:") }}
                </td>
                <td>
                  {{ license_info.plan_name }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- <v-dialog /> -->
  </div>
</template>

<script>
import SettingsMenu from "@/components/admin/SettingsMenu.vue";

import axios from "axios";

export default {
  components: {
    SettingsMenu
  },
  data() {
    return {
      document_title: this.T__("Plan ‹ Settings")
    };
  },
  computed: {
    license_info() {
      return this.$store.getters.get_license_info;
    }
  },
  methods: {
    show_change_email_confirmation() {
      let dialog_text =
        this.T__("This account email is used only for licensing purposes") +
        ' - <ul class="bull"><li>' +
        this.T__("Plugin activation and license validation") +
        "</li><li>" +
        this.T__("License expiry and renewal alerts") +
        "</li><li>" +
        this.T__("Plugin-related support and communication") +
        "</li></ul>";
      dialog_text += this.Tsprintf(
        /* translators: 1: html-tag-open 2: html-tag-close */
        this.T__(
          "Are you looking to change the new/reschedule/ cancellation booking notification email? %1$s Click here %2$s."
        ),
        '<a href="https://help.wpcal.io/en/article/how-to-change-booking-notification-email-address-d2k93j/" target="_blank">',
        "</a>"
      );
      dialog_text += "<br><br><strong>" + this.T__("") + "</strong>";
      this.$modal.show("dialog", {
        title: this.T__("Change the account?"),
        text: dialog_text,
        buttons: [
          {
            title: this.T__("Yes, I'm sure"),
            handler: () => {
              this.$router.push({
                //if path is set params will be ignored, hence using name here.
                name: "setting_account_login",
                params: { attempt_to_change_account: true }
              });
              this.$modal.hide("dialog");
            }
          },
          {
            title: this.T__("No, don't."),
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ]
      });
    },
    force_validate_next_instance_and_dummy_call() {
      let wpcal_request = {};
      let action = "force_validate_next_instance";
      wpcal_request[action] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {})
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.dummy_call();
        });
    },
    dummy_call() {
      let wpcal_request = {};
      let action = "dummy__";
      wpcal_request[action] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {})
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
